import axios from '@/http/apiRequest';


// 获取当前账号信息
export const getHostInfo = (params?, useAbort?) => {
  return axios.request({
    method: 'GET',
    url: '/api/currentHostInfo',
    useAbort,
    params,
  })
};

// 发送验证码
export const sendCaptcha = (type,data) => {
  return axios.request({
    method: "POST",
    // url: "/api/captcha/send",
    url: `/api/captcha/send/${type}`,
    data
  })
};


// 查询登录用户联系人
export const getCaptchaContacts = () => {
  return axios.request({
    method: 'GET',
    url: '/api/captcha/contacts'
  })
};


// 登录接口
export const LOGIN = (data) => {
  return axios.request({
    method: "POST",
    url: `/api/login`,
    data
  })
};


// 退出登录
export const logout = (data?) => {
  return axios.request({
    method: "POST",
    url: `/api/logout`,
    data
  })
};


// 刷新当前登录主机的信息
export const refreshHostInfo = (params?) => {
  return axios.request({
    method: "GET",
    url: `/api/refreshHostInfo`,
    params,
  })
};

// 获取agentcode下所有站点接口
export const getAllHostList = (pageIndex,pageSize,data) => {
  return axios.request({
    method: "POST",
    url: `/api/vhost/getAllHostList/${pageIndex}/${pageSize}`,
    data,
  })
};

// 切换用户登录的主机信息，只有免登方式登录可切
export const changeHost = (data?) => {
  return axios.request({
    method: "POST",
    url: `/api/changeHost`,
    data,
  })
};

// 获取登录方式
export const getLoginSource = () => {
  return axios.request({
    method: "GET",
    url: `/api/getLoginSource`,
  })
};